import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Modal,
  ModalDialog,
} from '@mui/joy';
import ShipmentTrackingContent from '../../../tracking_event/widgets/ShipmentTrackingContent';

export default function ShipmentTrackingModal({ open, onClose, shipmentId }) {
  const { t } = useTranslation('ui');

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        variant="outlined"
        sx={{
          maxWidth: 720,
          width: '95vw',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          p: 0,
        }}
      >
        <DialogContent
          sx={{
            px: 2,
            py: 2,
            overflow: 'auto',
            flex: 1,
          }}
        >
          {open && shipmentId ? (
            <ShipmentTrackingContent shipmentId={shipmentId} variant="modal" />
          ) : null}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ px: 2.5, py: 1.5 }}>
          <Button variant="plain" color="neutral" onClick={onClose}>
            {t('actions.close')}
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  );
}
